import { subHours, subDays } from "date-fns";
import {
  ServerURL,
  getAccessToken,fetch_instance,
  CreateUserMethodAPIUrl,
  CustomUserListMethodURL,
  UserGetPermittedActionApiMethodUrl,
  UserResetMethodAPIUrl,
  CustomerResetMethodAPIUrl,
  ShipperResetMethodAPIUrl,
} from "./ServerConfig";
import toast from "react-hot-toast";


class user_api {
  // The user-picker list. Defaults to office staff (no shippers/customers).
  // Takes anything URLSearchParams takes, so callers control the query.
  async custom_user_list(params = { simple: "true", is_staff: "true" }) {
    const query = new URLSearchParams(params);

    try {
      const response = await fetch_instance(
        `${ServerURL}${CustomUserListMethodURL}?${query.toString()}`,
        { method: "GET", headers: { Authorization: `Bearer ${getAccessToken()}` } }
      );
      if (!response.ok) throw new Error(`Error ${response.status}`);
      const data = await response.json();
      return Array.isArray(data) ? data : data?.results || [];
    } catch (error) {
      toast.error(error.message || "Failed to load users");
      return [];
    }
  }

  async check_user_permission(perm) {
    let result = {};

    await fetch_instance(`${ServerURL}customization/check_user_permission`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getAccessToken()}`,
      },
      body: JSON.stringify({
        perm: perm,
      }),
    }).then((response) => {
      // console.log(response);
      // result = response;
      return response.json()
    }).then((data) => {
      result = data;
      // console.log(data);
      return Promise.resolve(result);
    });
    return Promise.resolve(result);
  }

async getUsers(options = {}) {
  const { apply_follow_up = false } = options;

  try {
    const params = new URLSearchParams({
      ...(apply_follow_up && { apply_follow_up: "true" }),
    });

    const response = await fetch_instance(
      `${ServerURL}users/${params.toString() ? `?${params.toString()}` : ""}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error ${response.status}: ${errorText}`);
    }

    const data = await response.json();
    return data || [];
  } catch (error) {
    console.error("getUsers error:", error);
    toast.error(error.message || "Failed to load users");
    return [];
  }
}

  // getInvoice() {
  //   const invoice = {
  //     id: '5ecb86785312dcc69b5799ad',
  //     currency: '$',
  //     customer: {
  //       address: '271 Richmond Rd, Grey Lynn, Auckland 1022, New Zealand',
  //       company: 'Countdown Grey Lynn',
  //       email: 'contact@anahenisky.io',
  //       name: 'Ana Henisky',
  //       taxId: '6934656584231'
  //     },
  //     dueDate: now.getTime(),
  //     issueDate: subHours(now, 1).getTime(),
  //     items: [
  //       {
  //         id: '5ecb8694db1760a701dfbf74',
  //         currency: '$',
  //         description: 'Freelancer Subscription (12/05/2019 - 11/06/2019)',
  //         unitAmount: 55.50
  //       }
  //     ],
  //     number: 'DEV-9483',
  //     status: 'paid',
  //     subtotalAmount: 50.00,
  //     taxAmount: 5.50,
  //     totalAmount: 55.50
  //   };

  //   return Promise.resolve(invoice);
  // }

  async create_user(obj) {
    let result = {};

    await fetch_instance(`${ServerURL}${CreateUserMethodAPIUrl}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getAccessToken()}`,
      },
      body: JSON.stringify(obj),
    }).then((response) => {
      // console.log(response);
      result = response;
      // return Promise.resolve(result)
    });
    return Promise.resolve(result);
  }
  async reset_password(obj) {
    let result = {};

    await fetch_instance(`${ServerURL}${UserResetMethodAPIUrl}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getAccessToken()}`,
      },
      body: JSON.stringify(obj),
    }).then((response) => {
      // console.log(response);
      result = response;
      // return Promise.resolve(result)
    });
    return Promise.resolve(result);
  }
  async customer_reset_password(obj) {
    let result = {};

    await fetch_instance(`${ServerURL}${CustomerResetMethodAPIUrl}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getAccessToken()}`,
      },
      body: JSON.stringify(obj),
    }).then((response) => {
      // console.log(response);
      result = response;
      // return Promise.resolve(result)
    });
    return Promise.resolve(result);
  }
  async shipper_reset_password(obj) {
    let result = {};

    await fetch_instance(`${ServerURL}${ShipperResetMethodAPIUrl}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getAccessToken()}`,
      },
      body: JSON.stringify(obj),
    }).then((response) => {
      // console.log(response);
      result = response;
      // return Promise.resolve(result)
    });
    return Promise.resolve(result);
  }
  async user_has_permission(model, perm_type) {
    let has_permission = false;

    await fetch_instance(`${ServerURL}${UserGetPermittedActionApiMethodUrl}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getAccessToken()}`,
      },
      body: JSON.stringify({
        model: model,
        perm_type: perm_type,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        has_permission = data.has_permission || false;
      })
      .catch((error) => {
        toast.error(error.toString());
        console.log(error);
      });
    return Promise.resolve(has_permission);
  }
}

export const UserApi = new user_api();
